import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import type { InventoryResource } from '@repo/api-gw-sdk';

import { useDAL } from '@/contexts/useDAL';
import { DynamoDbBillingModes } from '@/data/inventory/data';
import { defaultDynamoDbConfiguration } from '@/data/inventory/dynamoDB';

export const DynamoDBPropertiesSection = ({
  resource,
}: {
  resource: InventoryResource;
}) => {
  const properties = resource.resourceProperties?.awsDynamoDb;

  return (
    <Table
      className='w-full'
      sx={{
        '& .props-col': {
          verticalAlign: 'top',
          width: '225px',
          paddingLeft: '40px',
        },
      }}
    >
      <TableBody>
        {properties?.billingMode &&
          DynamoDbBillingModes[properties.billingMode]?.name && (
            <TableRow>
              <TableCell
                className='props-col'
                sx={{
                  borderTop: '1px solid var(--mui-palette-TableCell-border)',
                }}
              >
                Billing mode
              </TableCell>
              <TableCell
                sx={{
                  borderTop: '1px solid var(--mui-palette-TableCell-border)',
                }}
              >
                {DynamoDbBillingModes[properties.billingMode].name}
              </TableCell>
            </TableRow>
          )}
        {typeof properties?.readCapacityUnits === 'number' && (
          <TableRow>
            <TableCell className='props-col'>Read capacity units</TableCell>
            <TableCell>{properties.readCapacityUnits}</TableCell>
          </TableRow>
        )}
        {typeof properties?.writeCapacityUnits === 'number' && (
          <TableRow>
            <TableCell className='props-col'>Write capacity units</TableCell>
            <TableCell>{properties.writeCapacityUnits}</TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};

export const DynamoDBBackupConfigurationSection = ({
  resource,
}: {
  resource: InventoryResource;
}) => {
  const dal = useDAL();
  const { data: resourceConfigResponse } =
    dal.inventory.backupConfiguration.dynamodb.get(
      undefined,
      resource.providerResourceId
    );

  const { data: accountConfigResponse } =
    dal.inventory.backupConfiguration.dynamodb.get(resource.providerAccountId);

  const { data: globalConfigResponse } =
    dal.inventory.backupConfiguration.dynamodb.get();

  const config =
    resourceConfigResponse ||
    accountConfigResponse ||
    globalConfigResponse ||
    defaultDynamoDbConfiguration;

  return (
    <Table
      className='w-full'
      sx={{
        '& .props-col': {
          verticalAlign: 'top',
          width: '225px',
          paddingLeft: '40px',
        },
      }}
    >
      <TableBody>
        <TableRow>
          <TableCell className='props-col'>Autoscale</TableCell>
          <TableCell>
            {config.isAutoscaleEnabled ? 'Enabled' : 'Disabled'}
          </TableCell>
        </TableRow>
        {!config.isAutoscaleEnabled &&
          typeof config.maxReadCapacityPercentage === 'number' && (
            <TableRow>
              <TableCell className='props-col'>Maximum read capacity</TableCell>
              <TableCell>{`${config.maxReadCapacityPercentage}%`}</TableCell>
            </TableRow>
          )}
        {!config.isAutoscaleEnabled &&
          typeof config.maxReadCapacityUnits === 'number' &&
          typeof config.maxReadCapacityPercentage !== 'number' && (
            <TableRow>
              <TableCell className='props-col'>
                Maximum read capacity units
              </TableCell>
              <TableCell>{config.maxReadCapacityUnits}</TableCell>
            </TableRow>
          )}
      </TableBody>
    </Table>
  );
};
